import {
  NAMESPACE,
  paginationModule,
  perPageSelectDefaultOptions,
} from '@core/store/submodules/pagination';

/**
 * BaseStoreModule wraps all the regular Vuex module internals
 * and exposes "modules" property to add submodules such as pagination/sorting/others
 * @param config
 * @param config.namespaced {Boolean}
 * @param config.state {Object}
 * @param config.actions {Object}
 * @param config.mutations {Object}
 * @param config.getters {Object}
 * @param config.submodules {Object}
 * @param config.submodules.pagination {Object} - pagination
 * @param config.submodules.pagination.enabled {Boolean} - is pagination enabled
 * @param config.submodules.pagination.totalPages {Number}
 * @param config.submodules.pagination.currentPage {Number}
 * @param config.submodules.pagination.perPage {Number}
 * @param config.submodules.pagination.perPageOptions {Array} - {id: '10', value: 10}
 * @return {{modules: *, mutations: *, state: *, getters: *, actions: *, namespaced: boolean}}
 * @constructor
 */
export const BaseStoreModule = (config) => {
  const {
    namespaced = true,
    state,
    actions,
    mutations,
    getters,
    submodules = {
      pagination: {},
      sort: {},
      filter: {},
    },
  } = config;
  // creating Vuex module base
  const vuexStoreModule = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
    modules: {},
  };
  // setting submodules
  if (submodules.pagination.enabled) {
    const {
      widgetName,
      currentPage = 1,
      totalPages = 0,
      pageSize = 25,
      perPageOptions = perPageSelectDefaultOptions,
    } = submodules.pagination;
    vuexStoreModule.modules[NAMESPACE] = paginationModule({
      widgetName,
      currentPage,
      totalPages,
      pageSize,
      perPageOptions,
    });
  }
  return vuexStoreModule;
};
